import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, mergeMap } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  UpdateMerch,
  UpdateMerchSuccess,
  UpdateMerchError,
  RedirectToMerchPage,
  PublishProduct,
  // RedirectToCatalogPage,
  CleanMerchStore,
  RedirectMerchSuccessPage,
} from '../action-creators';
import { UPDATE_MERCH } from '../actions';
import ApiError from '@common/types/api/api-error';

export const updateMerchEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, UpdateMerch>(UPDATE_MERCH),
    mergeMap(async (action) => {
      try {
        const response = await merch.editMerch(
          action.data,
          action.productId,
          action.artistId
        );
        const results: Actions[] = [
          new UpdateMerchSuccess({
            ...response,
            sampleImages: response.sampleImages?.map(
              (image) => `${image}?v=${Date.now()}`
            ),
          }),
        ];
        if (action.finish) {
          if (response.status === 'draft') {
            results.push(new PublishProduct(action.artistId, action.productId));
          }
          results.push(new RedirectMerchSuccessPage(action.productId));
          results.push(new CleanMerchStore());
        } else if (action.sampleOrder && action.orderId) {
          if (response.status === 'draft') {
            results.push(new PublishProduct(action.artistId, action.productId));
            results.push(
              new UpdateMerchSuccess({ ...response, status: 'published' })
            );
          }

          results.push(
            new RedirectToMerchPage(
              '',
              `/merch-order/payment?orderId=${action.orderId}`
            )
          );
        }
        return results;
      } catch (err) {
        return [new UpdateMerchError((err as ApiError).message)];
      }
    }),
    concatMap((actions) => actions)
  );
